<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('price_details') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('price_edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_s') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.price_s" class="d-flex align-items-center">
								<span>$ {{ price_s }}</span>
							</div>
						</div>
					</div>
				</div>		
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_d') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.price_d" class="d-flex align-items-center">
								<span>$ {{ price_d }}</span>
							</div>
						</div>
					</div>
				</div>	
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_ds') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.price_ds" class="d-flex align-items-center">
								<span>$ {{ price_ds }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_rs') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.price_rs" class="d-flex align-items-center">
								<span>$ {{ price_rs }}</span>
							</div>
						</div>
					</div>
				</div>
				<template v-if="detailsData.price_s > 0">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_summ') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.price_c" class="d-flex align-items-center">
								<span>$ {{ price_summ }}</span>
							</div>
						</div>
					</div>
				</div>
				</template>
				<template v-if="detailsData.price_c > 0">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_summ_c') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.price_c" class="d-flex align-items-center">
								<span>{{ numberWithCurrencyMuseum(price_summ_c) }}</span>
							</div>
						</div>
					</div>
				</div>	
				</template>
				<template v-if="detailsData.price_ok > 0">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_ok') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.price_c" class="d-flex align-items-center">
								<span>{{ numberWithCurrencyMuseum(price_ok) }}</span>
							</div>
						</div>
					</div>
				</div>	
				</template>
			</div>

			<div v-show="!isDetailsActive">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price_s') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.price_s"
							           :error-message="$errorMessage(errors, 'price_s')"
										    :placeholder="$t('enter_price_s')"
							           type="number"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price_d') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.price_d"
							           :error-message="$errorMessage(errors, 'price_d')"
										    :placeholder="$t('enter_price_d')"
							           type="number"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price_ds') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.price_ds"
							           :error-message="$errorMessage(errors, 'price_ds')"
										    :placeholder="$t('enter_price_ds')"
							           type="number"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price_rs') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.price_rs"
							           :error-message="$errorMessage(errors, 'price_rs')"
										    :placeholder="$t('enter_price_rs')"
							           type="number"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price_c') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.price_c"
							           :error-message="$errorMessage(errors, 'price_c')"
										    :placeholder="$t('enter_price_c')"
							           type="number"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price_ok') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.price_ok"
							           :error-message="$errorMessage(errors, 'price_ok')"
										    :placeholder="$t('enter_price_ok')"
							           type="number"/>
						</div>
					</div>
				</div>
	
				
				


			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator, numberWithCurrencyMuseum} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformationFund",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			urlGenerator,
			numberWithCurrencyMuseum,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
		
			
			countryList: [],
		
			errors: {}
		}
	},
	computed: {
		contentTypeList() {
			return this.$store.getters.contentType
		},
	
		ownerList() {
			return this.$store.getters.getOwner
		},
		
		
		
		
		price_s() {
			return  parseFloat(this.detailsData.price_s).toFixed(2);
		},
		price_d() {
			return  parseFloat(this.detailsData.price_d).toFixed(2);
		},
		price_ds() {
			return  parseFloat(this.detailsData.price_ds).toFixed(2);
		},
		price_rs() {
			return  parseFloat(this.detailsData.price_rs).toFixed(2);
		},
		price_c() {
			return  parseFloat(this.detailsData.price_c).toFixed(2);
		},
		price_ok() {
			return  parseFloat(this.detailsData.price_ok).toFixed(2);
		},
		
		
		price_summ() {
			var prsm = parseFloat(this.detailsData.price_s) + parseFloat(this.detailsData.price_d) + parseFloat(this.detailsData.price_ds) + parseFloat(this.detailsData.price_rs);
			return prsm.toFixed(2);
		},
		
		price_summ_c() {
			var prsmc = parseFloat(this.price_summ) * parseFloat(this.detailsData.price_c);
			return prsmc.toFixed(2);
		},
	
		
		
		
		
		peopleList() {
			return this.$store.getters.getPerson
		},
		organizationList() {
			return this.$store.getters.getOrganization
		},
	},
	methods: {
		detailsInfoSync() {

			this.formData.name = this.detailsData.name;
			
			this.formData.year_on = this.detailsData.year_on;
			this.formData.year_off = this.detailsData.year_off;
			this.formData.cond = this.detailsData.cond;
			this.formData.country_made = this.detailsData.country_made;
			this.formData.country_buy = this.detailsData.country_buy;
			this.formData.inrest_id = this.detailsData.inrest_id;
			
			this.formData.type_owners = this.detailsData.type_owners;
			
			this.formData.date_buy = this.detailsData.date_buy ? moment(this.detailsData.date_buy).format(
        "YYYY-MM-DD"
      ) : null;

			
			this.formData.price_s = this.detailsData.price_s;
			this.formData.price_d = this.detailsData.price_d;
			this.formData.price_ds = this.detailsData.price_ds;
			this.formData.price_rs = this.detailsData.price_rs;
			this.formData.price_c = this.detailsData.price_c;
			this.formData.price_ok = this.detailsData.price_ok;
			
		
			
			
			this.formData.size = this.detailsData.size;
			this.formData.material = this.detailsData.material;
			this.formData.designer = this.detailsData.designer;
			this.formData.who = this.detailsData.who;
			this.formData.rest = this.detailsData.rest;
			this.formData.org = this.detailsData.org;
			
			
			this.formData.fund_type_id = this.detailsData.fund_type_id;
			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
		},
		detailsInfoEdit() {
			this.isDetailsActive = false
		},
		getAllCountrys() {
			this.axiosGet(`crm/country`).then(({data}) => {
				this.countryList = data;
			});
		}
		
	},
	created() {
		this.$store.dispatch('contentType');
		this.$store.dispatch('getOwner');
		
		
		
		this.$store.dispatch('getPerson');
		this.$store.dispatch('getOrganization');
		this.getAllCountrys();
	},
}
</script>

